import { AppRoutes, buildRoute } from '@/route/routeConfig';

export interface AccountSettingsRoutes {
  profile: string;
  notifications: string;
  company: string;
}

export function getAccountSettingsRoutes(isSuper: boolean): AccountSettingsRoutes {
  if (isSuper) {
    return {
      profile: buildRoute(AppRoutes.OS_SETTINGS_PROFILE),
      notifications: buildRoute(AppRoutes.OS_SETTINGS_NOTIFICATIONS),
      company: buildRoute(AppRoutes.OS_SETTINGS_COMPANY),
    };
  }

  return {
    profile: buildRoute(AppRoutes.SETTINGS_PROFILE),
    notifications: buildRoute(AppRoutes.SETTINGS_NOTIFICATIONS),
    company: buildRoute(AppRoutes.SETTINGS_COMPANY),
  };
}
